const o = "颜色字段，当前颜色为 {color}", r = "Color field", l = "Colors palette", e = "预设颜色", t = "Custom preset colors", c = "Add color", s = "清除颜色", C = "Custom color, HEX format", d = "将颜色添加到自定义颜色列表", n = "清除自定义颜色字段", a = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: r,
  palette: l,
  presetColors: e,
  customColors: t,
  addColor: c,
  clearColor: s,
  colorField: C,
  colorFieldConfirm: d,
  colorFieldClear: n,
  deleteColorDescriber: a
};
export {
  c as addColor,
  s as clearColor,
  C as colorField,
  n as colorFieldClear,
  d as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  a as deleteColorDescriber,
  r as emptyColor,
  l as palette,
  e as presetColors
};
